module.exports = __webpack_public_path__ + "img/202501_04.e852722c.jpg";